import { z } from 'zod'

export const deliveryHistorySchema = z.object({
  date: z
    .string()
    .min(1),

  type: z
    .enum([ 'nvd', 'cs', 'abortion', 'other' ]),

  age: z
    .string()
    .optional(),

  sex: z
    .enum([ 'm', 'f', 'unknown' ])
    .optional(),

  details: z
    .string()
    .optional()
})

export const deliveryHistoryTableSchema = deliveryHistorySchema.extend({
  id: z.string()
})

export type DeliveryState = z.infer<typeof deliveryHistorySchema>
export type DeliveryTableData = z.infer<typeof deliveryHistoryTableSchema> & Record<string, unknown>
